import React, { useState, useEffect } from 'react';
import { api } from 'common';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import '../assets/css/login-styles.css';
import logo from '../assets/img/logo138x75white.png';

export default function LoginPage() {
  const {
    sendResetMail,
    verifyEmailPassword,
  } = api;

  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  // settings not needed for email/password-only login
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({ email: '', password: '' });
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [errors, setErrors] = useState({ email: '', password: '' });

  useEffect(() => {
    if (auth && auth.profile && auth.profile.uid) {
      const role = auth.profile.usertype;
      if (role === 'admin' || role === 'fleetadmin') navigate('/dashboard');
      else navigate('/');
    }
  }, [auth, navigate]);

  const onInputChange = (event) => {
    const { id, value } = event.target;
    setData(prev => ({ ...prev, [id]: value }));
    // clear error for the field while typing
    setErrors(prev => ({ ...prev, [id]: '' }));
  };

  const validateEmail = (value) => {
    const v = (value || '').trim();
    if (!v) return 'Champ requis.';
    const re = /^\S+@\S+\.\S+$/;
    if (!re.test(v)) return "Adresse e-mail invalide.";
    return '';
  };

  const validatePassword = (value) => {
    const v = (value || '').trim();
    if (!v) return 'Champ requis.';
    if (v.length < 6) return 'Trop court.';
    return '';
  };

  const onBlurEmail = () => {
    const err = validateEmail(data.email);
    setErrors(prev => ({ ...prev, email: err }));
  };

  const onBlurPassword = () => {
    const err = validatePassword(data.password);
    setErrors(prev => ({ ...prev, password: err }));
  };

  const showAlert = (msg) => setCommonAlert({ open: true, msg });

  const handleLogin = async (e) => {
    e && e.preventDefault();
    setIsLoading(true);
  const email = (data.email || '').trim();
  const password = (data.password || '').trim();
  if (!email) { showAlert('Veuillez entrer une adresse e-mail valide.'); setIsLoading(false); return; }
  if (!password) { showAlert('Veuillez entrer votre mot de passe.'); setIsLoading(false); return; }
  await dispatch(verifyEmailPassword(email, password));
    setIsLoading(false);
  };

  const forgotPassword = async (e) => {
    e && e.preventDefault();
    const email = (data.email || '').trim();
    if (!email) { showAlert('Veuillez entrer une adresse e-mail valide.'); return; }
    await dispatch(sendResetMail(email));
    showAlert('Email envoyé.');
  };

  return (
    <div className="login-container">
      {/* background video & overlay */}
      <div className="login-video-wrap">
        <video className="login-bg-video" autoPlay muted loop playsInline poster="/assets/img/logo138x75white.png">
          <source src="https://res.cloudinary.com/daroyxenr/video/upload/v1757863443/kling_20250914_Image_to_Video_fais_roule_5915_0_online-video-cutter.com_uezdha.mp4" type="video/mp4" />
        </video>
        <div className="login-video-overlay" />
      </div>
      <div className="login-card">
        <div className="login-header">
          <img src={logo} alt="logo" className="logo" />
          <h2>Administration</h2>
          <p>Connectez-vous en tant qu'administrateur</p>
        </div>

  <form id="loginForm" className="login-form" onSubmit={(e) => { e.preventDefault(); handleLogin(e); }}>
          <div className="form-group">
            <div className={`input-wrapper ${errors.email ? 'invalid' : ''}`}>
              <input id="email" name="email" value={data.email} onChange={onInputChange} onBlur={onBlurEmail} placeholder="Adresse e-mail" />
              <label htmlFor="email">Adresse e-mail</label>
              <span className="focus-border" />
              {errors.email ? <div className="field-error">{errors.email}</div> : null}
            </div>
          </div>

          <div className="form-group">
            <div className={`input-wrapper ${errors.password ? 'invalid' : ''}`}>
              <input id="password" name="password" type="password" value={data.password} onChange={onInputChange} onBlur={onBlurPassword} placeholder="Mot de passe" />
              <label htmlFor="password">Mot de passe</label>
              <span className="focus-border" />
              {errors.password ? <div className="field-error">{errors.password}</div> : null}
            </div>
          </div>

          <div className="form-options">
            <label className="remember-wrapper">
              <input type="checkbox" id="remember" name="remember" />
              <span className="checkbox-label"><span className="checkmark" /> Se souvenir de moi</span>
            </label>
            <button className="forgot-password" onClick={forgotPassword} style={{ background: 'none', border: 'none', color: '#4b5563', cursor: 'pointer' }}>Mot de passe oublié ?</button>
          </div>

          <button type="submit" className={`btn ${isLoading ? 'loading' : ''}`}>
            <span className="btn-text">Se connecter</span>
            <span className="btn-loader" />
          </button>
        </form>

        <div className="divider">ou</div>

        <div className="signup-link">
          <p>Contactez l'administrateur pour obtenir un compte.</p>
        </div>

        {commonAlert.open ? (
          <div className="alert">{commonAlert.msg}</div>
        ) : null}
      </div>
    </div>
  );
}